export default "dist/images/6caf35202b10b52e1fc2743f674c33e8.png";